import React from 'react';
import App from './../app';
import DashboardV3 from './../pages/dashboard/dashboard-v3';
import { Calendar } from './../pages/calendar/calendar';
import Map from './../pages/map/map';
import KanbanBoard from './../pages/kanban-board/kanban-board';
import { UserDebug } from '../pages/user/user-debug';
import { UserGraph } from '../pages/user/user-graph';

import { PropertySearch } from '../pages/properties/property-search';
import { PropertyDetail } from '../pages/properties/property-detail';
import { RoomDetails } from '../pages/properties/room-details';
import { PropertyBrochurePrint } from '../pages/properties/property-brochure-print';
import { TaskDetail } from '../components/properties/task-detail';

import { ExtraFileManager } from '../pages/documents/file-manager';
import { LandlordSearch } from '../pages/company/landlord-search';
import { LandlordDetail } from '../pages/company/landlord-detail';

import { UserSettings } from '../pages/user/user-settings';
import { ManageUsers } from '../pages/user/manage-users';

import { CompanySearch } from '../pages/company/company-search';
import { CompanyDetail } from '../pages/company/company-detail';

import { TenantDetail } from '../pages/tenants/tenant-detail';
import { InventoryDetail } from '../pages/tenants/inventory-detail';
import { InventoriesList } from '../pages/tenants/inventories-list';
import { TenantSearch } from '../pages/tenants/tenant-search';
import { RentTracker } from '../pages/tenants/rent-tracker';

const AppRoute = () => {


	const mainRoute = {
		path: '*',
		element: <App />,
		children: []
	}

	mainRoute.children.push({ path: '', element: <DashboardV3 /> });
	mainRoute.children.push({ path: 'dashboard', element: <DashboardV3 /> });
	mainRoute.children.push({ path: 'calendar', element: <Calendar /> });

	mainRoute.children.push({ path: 'kanban/:id', element: <KanbanBoard /> });
	mainRoute.children.push({ path: 'kanban', element: <KanbanBoard /> });
	mainRoute.children.push({ path: 'kanban/:boardId/task/:taskId', element: <TaskDetail /> });

	mainRoute.children.push({ path: 'user-debug', element: <UserDebug /> });
	mainRoute.children.push({ path: 'user-graph', element: <UserGraph /> });

	mainRoute.children.push({ path: 'property/search', element: <PropertySearch /> });
	mainRoute.children.push({ path: 'property/map', element: <Map /> });
	mainRoute.children.push({ path: 'property/detail/:id', element: <PropertyDetail /> });
	mainRoute.children.push({ path: 'property/detail/:id/brochure-print', element: <PropertyBrochurePrint /> });
	mainRoute.children.push({ path: 'property/:propertyId/room/:roomId', element: <RoomDetails /> });
	mainRoute.children.push({ path: 'property/:propertyId/maintenance/:maintenanceId', element: <TaskDetail /> });
	mainRoute.children.push({ path: 'property/:propertyId/inspection/:inspectionId', element: <TaskDetail /> });

	mainRoute.children.push({ path: 'docs/file-manager', element: <ExtraFileManager /> });

	mainRoute.children.push({ path: 'landlords/search', element: <LandlordSearch /> });
	mainRoute.children.push({ path: 'landlords/detail/:id/:tab', element: <LandlordDetail /> });
	mainRoute.children.push({ path: 'landlords/detail/:id', element: <LandlordDetail /> });
	
	mainRoute.children.push({ path: 'user/:id', element: <UserSettings /> })
	mainRoute.children.push({ path: 'users/manage', element: <ManageUsers /> });

	mainRoute.children.push({ path: 'company/search', element: <CompanySearch /> });
	mainRoute.children.push({ path: 'company/detail/:id/:tab', element: <CompanyDetail /> });
	mainRoute.children.push({ path: 'company/detail/:id', element: <CompanyDetail /> });

	mainRoute.children.push({ path: 'tenant/search', element: <TenantSearch /> });

	// Top-level inventory routes (standalone pages) so inventories open as full pages instead of nested tabs
	mainRoute.children.push({ path: 'tenant/:id/tenancy/:tenancyIndex/inventories', element: <InventoriesList /> });
	mainRoute.children.push({ path: 'tenant/:id/inventory/:inventoryId', element: <InventoryDetail /> });

	// Nest inventory routes under tenant/detail/:id so they render inside TenantDetail's Outlet
	mainRoute.children.push({
		path: 'tenant/detail/:id',
		element: <TenantDetail /> ,
		children: [
			// More specific routes must come before the generic ':tab' route so they are not shadowed
			{ path: 'inventory/:inventoryId', element: <InventoryDetail /> },
			{ path: 'tenancy/:tenancyIndex/inventories', element: <InventoriesList /> },
			{ path: ':tab', element: <div /> },
			{ path: '', element: <div /> }
		]
	});
	mainRoute.children.push({ path: 'tenant/rent-tracker', element: <RentTracker /> });

	const routes = [mainRoute];

	return routes;
}

export default AppRoute;